import React, { useState } from "react";

import { Box, Card, Grid, Typography, Button, Tooltip, TableContainer, Modal, Table, TableBody, TableHead, Checkbox, TableCell, TableRow, IconButton, FormControl, TextField, CardContent, useTheme } from "@mui/material";
import ReportsHeader from "../../../components/ReportHeader";
import dayjs from "dayjs";
import 'dayjs/plugin/customParseFormat';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import { tokens } from "../../../theme/theme";
import GlobalConfig from "../../../config/date/GlobalConfig";

const FinishedParentRollList = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [FromDate, setFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [ToDate, setToDate] = useState(dayjs().format('DD/MMM/YYYY'));
    const [partyList, setPartyList] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('All');

    const handleDateChange2 = (date) => {
        setFromDate(dayjs(date));
    };
    const handleDateChange1 = (date) => {
        setToDate(dayjs(date));
    };
    const HandleClose = () => {
        // setReport_All(true);
        // setReport_SalesOrder(false);
    }


    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const [filters, setFilters] = useState({
        pr_number: '',
        release_no: '',
        // email: '',
        // workphone: '',
        status: '',
        // payales: '',
    });

    return (
        <>
            <Card style={{ backgroundColor: "transparent" }}>
                <Box style={{ backgroundColor: "#0277bd" }} flexDirection={'row'} p={'5px'}>
                    <ReportsHeader title={'Finished Parent Roll List'} subtitle="" callback={handleBackWinderMachineEntry} />
                </Box>
                <CardContent>
                    <Box display="flex" flexDirection={'column'}>

                        

                        <Box m='0px' display="flex" justifyContent={'space-between'}>
                            <Grid container spacing={1} justifyContent="start" style={{ marginTop: '0px' }}>
                                <Grid item lg={1.5} xs={1.5} xl={1.5}>
                                    <Typography mt={1} ml={0} style={{ fontSize: '14px' }}> Filter By : Period </Typography>
                                </Grid>
                                <Grid item lg={2} xs={4} xl={2}>
                                    <FormControl fullWidth size="small">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DatePicker
                                                // label="From date"
                                                style={{ marginLeft: '10px' }}
                                                id="FromDate"
                                                value={dayjs(FromDate)}
                                                onChange={(date) => handleDateChange2(date)}
                                                slotProps={{ textField: { size: 'small', } }}
                                                renderInput={(props) => <TextField {...props} />}
                                                autoFocus
                                                format="DD-MMM-YYYY" // Use the appropriate format string
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>

                                <Grid item lg={2} xs={4}  xl={2}>
                                    <FormControl fullWidth size="small" >
                                        <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                                            <DatePicker
                                                // label="To date"
                                                id="ToDate"
                                                value={dayjs(ToDate)}
                                                format="DD-MMM-YYYY"
                                                onChange={(date) => handleDateChange1(date)}
                                                slotProps={{ textField: { size: 'small', } }}
                                                renderInput={(props) => <TextField {...props} />}
                                            />
                                        </LocalizationProvider>
                                    </FormControl>
                                </Grid>
                            </Grid>

                            <Tooltip title="Close" onClick={HandleClose}>
                                <IconButton >
                                    <FileDownloadIcon style={{ color: "#1de9b6" }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                    <Box
                        gridColumn="span 9"
                        gridRow={"span 2"}
                        alignItems="center"
                        justifyContent="center"
                        padding={0.5}
                        marginTop={2}
                        
                        sx={{
                            "& .MuiTable-root": {
                                border: "none",
                                size: "small",
                            },
                            "& .MuiTableCell-root": {
                                borderBottom: "none",
                                // fontWeight: "bold",
                                border: "1px solid ",
                                borderColor: `${colors.primary[400]} !important`,
                            },
                            "& .name-column--cell": {
                                color: colors.greenAccent[300],
                            },
                            "& .MuiTableHead-root": {
                                // backgroundColor: colors.blueAccent[700],
                                borderBottom: "none",

                            },
                            "& .MuiTableBody-root": {
                                overflowY: "auto",
                            },
                            "& .MuiCheckbox-root": {
                                color: `${colors.blueAccent[200]} !important`,
                                size: "small",
                            },
                            "& .MuiTableFooter-root": {
                                borderTop: "none",
                                backgroundColor: colors.blueAccent[700],
                                height: "10px",
                            },
                            "& .MuiButton-text": {
                                color: `${colors.grey[100]} !important`,
                            },

                        }}>

                        <TableContainer >
                            <Table size="small">
                                <TableHead sx={{ height: 10 }}>
                                    <TableRow>
                                        <TableCell>
                                            <Checkbox size="small" style={{ color: "secondary" }}
                                            // indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                            // checked={selectedRows.length === filteredData.length}
                                            // onChange={handleSelectAllClick}
                                            />
                                        </TableCell>
                                        <TableCell>DATE</TableCell>
                                        <TableCell>PARENT ROLL NUMBER</TableCell>
                                        <TableCell>MO NUMBERS</TableCell>
                                        <TableCell>MA NUMBERS</TableCell>
                                        <TableCell>WEIGHT</TableCell>
                                        <TableCell>LENGTH</TableCell>
                                        <TableCell>STATUS</TableCell>

                                        <TableCell>
                                            <IconButton >
                                                {/* onClick={handleOpen}
                                                            <Searchicon style={{ fontSize: "16px" }} /> */}
                                            </IconButton>
                                            <Modal
                                                // open={open}
                                                // onClose={handleClose}
                                                aria-labelledby="modal-modal-title"
                                                aria-describedby="modal-modal-description"
                                            >
                                                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                    <TextField
                                                        label="Parent Roll Number"
                                                        name="name"
                                                        // value={filters.pr_number}
                                                        // onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                    />
                                                    <TextField
                                                        label="MA Number"
                                                        name="companyName"
                                                        // value={filters.release_no}
                                                        //onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                    />

                                                    <TextField
                                                        label="Status"
                                                        name="status"
                                                        // value={filters.status}
                                                        //onChange={handleFilterChange}
                                                        variant="outlined"
                                                        fullWidth
                                                        margin="normal"
                                                    />


                                                    <Button variant="contained" style={{ marginTop: 10 }}>
                                                        {/* onClick={handleClose} */}
                                                        Apply Filter
                                                    </Button>
                                                </Box>
                                            </Modal>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredData.map((row) => (
                                        <TableRow key={row.id}>
                                            <TableCell>
                                                <Checkbox
                                                    size="small"
                                                // checked={isSelected(row.id)}
                                                // onChange={(event) => handleRowCheckboxClick(event, row.id)}
                                                />
                                            </TableCell>
                                            <TableCell>{row.date}</TableCell>
                                            <TableCell>
                                                <span
                                                // style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                // onClick={() => handleCallEdit(row.id, row.pr_number)}
                                                >
                                                    {row.pr_number}
                                                </span>
                                            </TableCell>
                                            <TableCell>{row.release_no}</TableCell>
                                            <TableCell>{row.lot_no}</TableCell>
                                            <TableCell>{row.reel_weight}</TableCell>
                                            <TableCell>{row.reel_length}</TableCell>
                                            <TableCell>{row.status}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>

                </CardContent>

            </Card>

        </>
    )
};
export default FinishedParentRollList;